module.exports = __webpack_public_path__ + "static/media/strategy3.23177522.svg";